import mixitup from 'mixitup';

export default class InsightsFilter {

	constructor($el) {
		this.insightfilter = $el;
		this.filter = document.querySelector('[data-insight-filter]');

		this.setInitialCheckboxesState();

		this.mixer = mixitup(this.insightfilter, {
			selectors: {
				target: '.c-card-insight',
			},
			load: {
				filter: this.getSelectorFromHash(),
			},
			callbacks: {
				onMixEnd: (state, futureState) => {
					this.setHash(state, futureState);
				},
			},
		});

		this.filter.addEventListener('change', this.filterInsights.bind(this));

		window.onhashchange = () => {
			const selector = this.getSelectorFromHash();

			if (selector === this.mixer.getState().activeFilter.selector) return;

			this.mixer.filter(selector);
		};
	}

	setInitialCheckboxesState() {
		const hash = window.location.hash.replace(/^#/g, '');

		if (hash) {
			let currentSelectors = this.getSelectorFromHash();
			currentSelectors = currentSelectors.split(',');

			if (currentSelectors.length > 0) {
				currentSelectors.forEach((selector) => {
					const id = selector.replace('.', '');
					const $checkbox = this.filter.querySelector(`#${id}`);
					$checkbox.checked = true;
				});
			}
		}
	}

	filterInsights() {
		const checkedFilters = this.filter.querySelectorAll(':checked');
		let activeFilters = [];
		checkedFilters.forEach((filter) => {
			activeFilters.push(filter.value);
		});

		let filterString = activeFilters.join();

		if (activeFilters.length <= 0) {
			filterString = 'all';
		}

		this.mixer.filter(filterString);
	}

	getSelectorFromHash() {
		const hash = window.location.hash.replace(/^#/g, '');
		const selector = hash ? '.' + hash : '.c-card-insight';

		return selector;
	}

	setHash(state) {
		const selector = state.activeFilter.selector;
		const newHash = '#' + selector.replace(/^\./g, '');

		if (selector === '.c-card-insight' && window.location.hash) {
			history.pushState(null, document.title, window.location.pathname);
		} else if (newHash !== window.location.hash && selector !== '.c-card-insight') {
			history.pushState(null, document.title, window.location.pathname + newHash);
		}
	}
}
